import React, {useEffect} from "react";
import "./RequestsAdminPage.sass"
import {useDispatch, useSelector} from "react-redux";
import {close, closeRequest, getAllCourseRequests} from "../../../_actions/requestsService";
import {IDLE} from "../../../common/statuses";
import Window from "../../../_containers/window/Window";
import CircleButton from "../../../_components/common/buttons/CircleButton";
import CloseIcon from "@mui/icons-material/Close";
import {HOME} from "../../../common/links";
import {Paper, TableContainer} from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {StyledTableCell, StyledTableRow} from "../../../_components/TableComponents";
import TableBody from "@mui/material/TableBody";
import {formatPhone} from "../../../common/formater";
import ButtonComponent from "../../../_components/common/buttons/ButtonComponent";

export default function RequestsAdminPage() {

    const {data} = useSelector(state => state.requests.getRequests);
    const status = useSelector(state => state.requests.getRequests.status);
    const dispatch = useDispatch();

    useEffect(() => {
        if (status === IDLE) {
            dispatch(getAllCourseRequests())
        }
    }, [status, dispatch]);
    useEffect(() => {
        document.title = 'КьюАй - Заявки на курсы'
        return () => dispatch(closeRequest())
    }, [])

    const renderCourse = (course, isProcessed) => {
        if (!course) {
            return (
                <div style={{color: 'inherit'}}>N/A</div>
            )
        }

        const courseStyle = {
            backgroundColor: isProcessed ? 'rgba(0,0,0,0.05)' : course.color,
        }

        if (isProcessed) {
            courseStyle.color = 'inherit'
        }

        return (
            <div style={courseStyle}
                 className="course-item">
                {course.shortName}
            </div>
        )
    }

    const renderCloseButton = (id, isProcessed) => {
        if (isProcessed) {
            return <>Готово</>
        } else {
            return (
                <ButtonComponent onClick={() => dispatch(close(id))}>
                    Закрыть
                </ButtonComponent>
            )
        }
    }

    return (
        <Window>
            <div className="requests-admin-wrapper">
                <div className="requests-admin-title">Заявки на курсы</div>
                <div>
                    <CircleButton Icon={CloseIcon} link={HOME}/>
                </div>
            </div>
            <div>
                <TableContainer component={Paper}>
                    <Table>
                        <caption>{!data && "Загрузка..."}</caption>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>№</StyledTableCell>
                                <StyledTableCell>ФИО</StyledTableCell>
                                <StyledTableCell>Почта</StyledTableCell>
                                <StyledTableCell>Телефон</StyledTableCell>
                                <StyledTableCell>Курс</StyledTableCell>
                                <StyledTableCell>Город</StyledTableCell>
                                <StyledTableCell>Статус</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        {data &&
                            <TableBody>
                                {data.map((request) => {
                                    const {id, fullName, email, phoneNumber, course, city, isProcessed} = request
                                    let phone = formatPhone(phoneNumber)

                                    const style = {
                                        backgroundColor: isProcessed ? 'rgba(0,0,0,0.1) !important' : 'inherit',
                                        color: isProcessed ? 'rgba(0,0,0,0.3) !important' : 'inherit'
                                    }

                                    return (
                                        <StyledTableRow key={`request-${id}`} sx={style}>
                                            <StyledTableCell component="th" scope="row">
                                                {id}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {fullName}
                                            </StyledTableCell>
                                            <StyledTableCell sx={{width: '15em'}}>
                                                <a style={{textDecoration: 'none', color: 'inherit'}}
                                                   href={`mailto:${email}`}>
                                                    {email}
                                                </a>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <a style={{textDecoration: 'none', color: 'inherit'}}
                                                   href={`tel:${phone}`}>
                                                    {phone}
                                                </a>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {renderCourse(course, isProcessed)}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {city && city.name}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {renderCloseButton(id, isProcessed)}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    )
                                })}
                            </TableBody>
                        }
                    </Table>
                </TableContainer>
            </div>
        </Window>
    )
}